module.exports = __webpack_public_path__ + "img/RPM.3fbb2f72.svg";